var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[_c('p',{class:`${_vm.baseClass}__text ${_vm.baseClass}__text--action`,domProps:{"innerHTML":_vm._s(_vm.messages.actions[_vm.audit.payload.action])}}),_c('span',{class:[
      `${_vm.baseClass}__text`,
      `${_vm.baseClass}__text--object-type`,
      `${_vm.baseClass}__text--${_vm.objectTypeColor}`,
      `${_vm.baseClass}__text--${_vm.size}`,
    ]},[_vm._v("\n    "+_vm._s(_vm.objectTypeText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }